import React, { useState } from 'react';
import { MailIcon, PhoneIcon, ClockIcon, MapPinIcon } from 'lucide-react';
import { Input } from '../components/ui/Input';
import { Textarea } from '../components/ui/Textarea';
import { Select } from '../components/ui/Select';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { useTranslation } from '../lib/i18n';
const WEB3FORMS_ACCESS_KEY = 'b7789131-e060-4196-aa41-6a4c61a3a4d1';
const WEB3FORMS_ACTION = 'https://api.web3forms.com/submit';
export function ContactPage() {
  const {
    lang
  } = useTranslation();
  const en = lang === 'en';
  const ru = lang === 'ru';
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [submitError, setSubmitError] = useState<string | null>(null);
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitError(null);
    const formData = new FormData(e.currentTarget);
    const payload: Record<string, string> = {
      access_key: WEB3FORMS_ACCESS_KEY,
      subject: 'Kontakt upit - D-TECH Solutions',
      from_name: 'D-TECH sajt - kontakt',
      botcheck: ''
    };
    formData.forEach((value, key) => {
      if (typeof value === 'string') payload[key] = value;
    });
    setIsSubmitting(true);
    try {
      const response = await fetch(WEB3FORMS_ACTION, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(payload)
      });
      const result = await response.json();
      if (response.ok && result.success) {
        setIsSubmitting(false);
        setSubmitSuccess(true);
        if (typeof (window as any).gtag === 'function') {
          ;
          (window as any).gtag('event', 'generate_lead', {
            currency: 'EUR',
            value: 0,
            lead_source: 'contact_form'
          });
        }
      } else {
        setIsSubmitting(false);
        setSubmitError(en ? 'Sending failed. Please try again or contact us directly.' : ru ? 'Отправка не удалась. Пожалуйста, попробуйте еще раз или свяжитесь с нами напрямую.' : 'Slanje nije uspelo. Pokušajte ponovo ili nas kontaktirajte direktno.');
      }
    } catch (err) {
      setIsSubmitting(false);
      setSubmitError(en ? 'Network error. Please try again or contact us directly.' : ru ? 'Ошибка сети. Пожалуйста, попробуйте еще раз или свяжитесь с нами напрямую.' : 'Greška u mreži. Pokušajte ponovo ili nas kontaktirajte direktno.');
    }
  };
  return <main className="min-h-screen bg-dark-bg" data-id="element-662">
      <section className="py-20 bg-dark-surface border-b-2 border-dark-border" data-id="element-663">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-664">
          <h1 className="text-5xl md:text-6xl font-black text-white mb-6" data-id="element-665">
            <span className="text-brand-yellow" data-id="element-666">
              {en ? 'Contact' : ru ? 'Свяжитесь с' : 'Kontaktirajte'}
            </span>{' '}
            {en ? 'us' : ru ? 'нами' : 'nas'}
          </h1>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto" data-id="element-667">
            {en ? 'Get in touch with our team for product inquiries, technical support or partnership opportunities.' : ru ? 'Свяжитесь с нашей командой для запросов о продукции, технической поддержки или возможностей партнерства.' : 'Stupite u kontakt sa našim timom za upite o proizvodima, tehničku podršku ili mogućnosti partnerstva.'}
          </p>
        </div>
      </section>

      <section className="py-20" data-id="element-668">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-669">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-670">
            <div data-id="element-671">
              <h2 className="text-3xl font-black text-white mb-6" data-id="element-672">
                {en ? 'Send us a message' : ru ? 'Отправьте нам сообщение' : 'Pošaljite nam poruku'}
              </h2>
              {submitSuccess ? <Card data-id="element-673">
                  <div className="text-center py-8" data-id="element-674">
                    <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-675">
                      <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-676">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-677" />
                      </svg>
                    </div>
                    <h3 className="text-2xl font-bold text-white mb-2" data-id="element-678">
                      {en ? 'Message sent!' : ru ? 'Сообщение отправлено!' : 'Poruka poslata!'}
                    </h3>
                    <p className="text-gray-300" data-id="element-679">
                      {en ? 'Thank you for contacting us. We will get back to you shortly.' : ru ? 'Спасибо, что связались с нами. Мы ответим вам в ближайшее время.' : 'Hvala vam što ste nas kontaktirali. Uskoro ćemo vam se javiti.'}
                    </p>
                  </div>
                </Card> : <Card data-id="element-680">
                  <form onSubmit={handleSubmit} className="space-y-6" noValidate data-id="element-681">
                    <Input label={en ? 'Full name *' : ru ? 'Полное имя *' : 'Ime i prezime *'} type="text" name="Ime_i_prezime" required placeholder={en ? 'Your name' : ru ? 'Ваше имя' : 'Vaše ime i prezime'} data-id="element-682" />
                    <Input label={en ? 'Email *' : 'Email *'} type="email" name="email" required placeholder={en ? 'your@email.com' : ru ? 'vas.email@primer.com' : 'vas.email@primer.com'} data-id="element-683" />
                    <Input label={en ? 'Phone *' : ru ? 'Телефон *' : 'Telefon *'} type="tel" name="Telefon" required placeholder={en ? '+1 ...' : ru ? '+7 ...' : '+381 60 123 4567'} data-id="element-684" />
                    <Select label={en ? 'Inquiry type *' : ru ? 'Тип запроса *' : 'Tip upita *'} name="Tip_upita" required defaultValue="" options={[{
                  value: '',
                  label: en ? 'Select category...' : ru ? 'Выберите категорию...' : 'Izaberite kategoriju...',
                  disabled: true
                }, {
                  value: 'Stepenisne penjace',
                  label: en ? 'Stair climbers' : ru ? 'Лестничные подъемники' : 'Stepenišne penjače'
                }, {
                  value: 'Elektricna kolica',
                  label: en ? 'Electric carts' : ru ? 'Электрические тележки' : 'Električna kolica'
                }, {
                  value: 'Opsti upit',
                  label: en ? 'General inquiry' : ru ? 'Общий запрос' : 'Opšti upit'
                }]} data-id="element-685" />
                    <Textarea label={en ? 'Message *' : ru ? 'Сообщение *' : 'Poruka *'} name="Poruka" required placeholder={en ? 'Tell us about your needs or questions' : ru ? 'Расскажите нам о ваших потребностях или вопросах' : 'Recite nam o vašim potrebama ili pitanjima'} rows={6} data-id="element-686" />
                    {submitError && <div className="p-4 bg-red-500/10 border-2 border-red-500/50 rounded-industrial text-sm text-red-300" data-id="element-687">
                        {submitError}
                      </div>}
                    <Button type="submit" variant="primary" size="lg" disabled={isSubmitting} className="w-full" data-id="element-688">
                      {isSubmitting ? en ? 'Sending...' : ru ? 'Отправка...' : 'Šaljem...' : en ? 'Send message' : ru ? 'Отправить сообщение' : 'Pošalji poruku'}
                    </Button>
                    <p className="text-sm text-brand-yellow text-center font-semibold" data-id="element-689">
                      {en ? 'We respond to all inquiries within 24h.' : ru ? 'Мы отвечаем на все запросы в течение 24 часов.' : 'Odgovaramo na upit u roku od 24h.'}
                    </p>
                  </form>
                </Card>}
            </div>

            <div data-id="element-690">
              <h2 className="text-3xl font-black text-white mb-6" data-id="element-691">
                {en ? 'Contact information' : ru ? 'Контактная информация' : 'Kontakt informacije'}
              </h2>
              <div className="space-y-6" data-id="element-692">
                <Card data-id="element-693">
                  <div className="flex items-start space-x-4" data-id="element-694">
                    <div className="w-12 h-12 bg-brand-yellow rounded-industrial flex items-center justify-center flex-shrink-0" data-id="element-695">
                      <MailIcon className="w-6 h-6 text-dark-bg" data-id="element-696" />
                    </div>
                    <div data-id="element-697">
                      <h3 className="text-xl font-bold text-white mb-2" data-id="element-698">
                        {ru ? 'Эл. почта' : 'Email'}
                      </h3>
                      <a href="mailto:info@dtech.rs" className="text-brand-yellow hover:text-brand-yellow-dark transition-colors text-lg" data-id="element-699">
                        info@dtech.rs
                      </a>
                      <p className="text-sm text-gray-400 mt-2" data-id="element-700">
                        {en ? 'For all inquiries, quotes and support' : ru ? 'Для всех запросов, предложений и поддержки' : 'Za sve upite, ponude i podršku'}
                      </p>
                    </div>
                  </div>
                </Card>
                <Card data-id="element-701">
                  <div className="flex items-start space-x-4" data-id="element-702">
                    <div className="w-12 h-12 bg-brand-yellow rounded-industrial flex items-center justify-center flex-shrink-0" data-id="element-703">
                      <PhoneIcon className="w-6 h-6 text-dark-bg" data-id="element-704" />
                    </div>
                    <div data-id="element-705">
                      <h3 className="text-xl font-bold text-white mb-2" data-id="element-706">
                        {en ? 'Phone' : ru ? 'Телефон' : 'Telefon'}
                      </h3>
                      <a href="tel:+381653312811" className="text-brand-yellow hover:text-brand-yellow-dark transition-colors text-lg" data-id="element-707">
                        +381 65 331 2811
                      </a>
                      <p className="text-sm text-gray-400 mt-2" data-id="element-708">
                        {en ? 'Call us during working hours' : ru ? 'Звоните нам в рабочее время' : 'Pozovite nas u toku radnog vremena'}
                      </p>
                    </div>
                  </div>
                </Card>
                <Card data-id="element-709">
                  <div className="flex items-start space-x-4" data-id="element-710">
                    <div className="w-12 h-12 bg-brand-yellow rounded-industrial flex items-center justify-center flex-shrink-0" data-id="element-711">
                      <ClockIcon className="w-6 h-6 text-dark-bg" data-id="element-712" />
                    </div>
                    <div data-id="element-713">
                      <h3 className="text-xl font-bold text-white mb-2" data-id="element-714">
                        {en ? 'Working hours' : ru ? 'Часы работы' : 'Radno vreme'}
                      </h3>
                      <p className="text-gray-300 text-lg" data-id="element-715">
                        {en ? <>
                            Monday - Friday
                            <br data-id="element-716" />
                            10:00 - 17:00 (CET)
                          </> : ru ? <>
                            Понедельник - Пятница
                            <br data-id="element-717" />
                            10:00 - 17:00 (CET)
                          </> : <>
                            Ponedeljak - Petak
                            <br data-id="element-718" />
                            10:00 - 17:00 (CET)
                          </>}
                      </p>
                      <p className="text-sm text-gray-400 mt-2" data-id="element-719">
                        {en ? 'We respond to all inquiries within 24 business hours' : ru ? 'Мы отвечаем на все запросы в течение 24 рабочих часов' : 'Odgovaramo na sve upite u roku od 24 radna sata'}
                      </p>
                    </div>
                  </div>
                </Card>
                <Card data-id="element-720">
                  <div className="flex items-start space-x-4" data-id="element-721">
                    <div className="w-12 h-12 bg-brand-yellow rounded-industrial flex items-center justify-center flex-shrink-0" data-id="element-722">
                      <MapPinIcon className="w-6 h-6 text-dark-bg" data-id="element-723" />
                    </div>
                    <div data-id="element-724">
                      <h3 className="text-xl font-bold text-white mb-2" data-id="element-725">
                        {en ? 'Location' : ru ? 'Местоположение' : 'Lokacija'}
                      </h3>
                      <p className="text-gray-300" data-id="element-726">
                        Dimitrija Tucovića 42
                        <br data-id="element-727" />
                        11050 Beograd Zvezdara, Srbija
                      </p>
                      <p className="text-sm text-brand-yellow/80 mt-3 italic leading-relaxed" data-id="element-728">
                        {en ? '* The stated address represents the registered headquarters of the company. Business is conducted online, and product delivery is carried out via contracted transport and courier services.' : ru ? '* Указанный адрес представляет собой зарегистрированную штаб-квартиру компании. Бизнес ведется онлайн, а доставка продукции осуществляется через контрактные транспортные и курьерские службы.' : '* Navedena adresa predstavlja registrovano sedište društva. Poslovanje se obavlja online, a isporuka proizvoda vrši se putem ugovorenih transportnih i kurirskih službi.'}
                      </p>
                    </div>
                  </div>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>;
}